import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6e5c5140&"
import script from "./Profile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Profile.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports